export const PageLoader = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
    <div className="flex items-center gap-2">
      <div className="w-3 h-3 rounded-full bg-primary animate-bounce" />
      <div className="w-3 h-3 rounded-full bg-primary animate-bounce animation-delay-100" />
      <div className="w-3 h-3 rounded-full bg-primary animate-bounce animation-delay-200" />
    </div>
    <p className="text-muted text-sm font-medium">Loading...</p>
  </div>
);
